import App from './containers/App';
// For the `babel-polyfill` dependency below, see
// http://rackt.org/redux/docs/advanced/AsyncActions.html
// and search `note on fetch`
import 'babel-polyfill';
import configureStore from './store/configureStore';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import Root from './containers/Root';
import { Provider } from 'react-redux';
import routes from './routes';
import { createHistory, useBeforeUnload } from 'history';
import { useRouterHistory } from 'react-router';
import './lib/ReactTryCatchBatchingStrategy';
import { change } from './actions/history';

const historyConfig = { basename: '' };
const history = useRouterHistory(useBeforeUnload(createHistory))(historyConfig);

const initialState = {};
const store = configureStore({ initialState, history });

history.listenBefore((location, callback) => {
	store.dispatch(change(location, callback));
});

// This doesn't work on iPad Safari (9.3.5) or iPad Chrome 59. But why not add it for desktop
// browsers that support it? Also, on desktop with Chrome 51+, the custom message is not used.
history.listenBeforeUnload(location => {
	const state = store.getState();
	if (state.observations.isObserving) {
		return 'Warning: your observation timer is running. Abandon it?\n\nIt is recommended you pause it first.';
	}
});

render(
	<Root history={ history } routes={ routes } store={ store } />,
	document.getElementById('root')
);


document.addEventListener('keydown', event => {
	event = event || window.event;
	if (event.altKey && event.keyCode === 82) {
		unmountComponentAtNode(document.getElementById('root'));
		render(
			<Root history={ history } routes={ routes } store={ store } />,
			document.getElementById('root')
		);
		console.log('-------- Done remounting app');
	}
});



// WEBPACK FOOTER //
// ./frontend/olos/js/index.jsx